/* tslint:disable */

import { ReaderFragment } from "relay-runtime";
type AccountNavContent_user$ref = any;
export type DesignProfileStatus = "ACTIVE" | "DELETED" | "NEW" | "PENDING" | "%future added value";
export type TradeFirmLoyaltyStatus = "BLACKLISTED" | "ELIGIBLE" | "ENROLLED" | "NOT_ELIGIBLE" | "%future added value";
export type AccountNav_user$ref = any;
export type AccountNav_user = {
    readonly isVerifiedTrade: boolean | null;
    readonly profile: {
        readonly firstName: string | null;
    } | null;
    readonly conversationSummary: {
        readonly unread: number | null;
    } | null;
    readonly tradeFirm: {
        readonly profileStatus: DesignProfileStatus | null;
        readonly publicProfile: {
            readonly urlLabel: string | null;
        } | null;
        readonly loyalty: {
            readonly status: TradeFirmLoyaltyStatus | null;
        } | null;
    } | null;
    readonly " $fragmentRefs": AccountNavContent_user$ref;
    readonly " $refType": AccountNav_user$ref;
};



const node: ReaderFragment = ({
    "kind": "Fragment",
    "name": "AccountNav_user",
    "type": "User",
    "metadata": null,
    "argumentDefinitions": [],
    "selections": [
        {
            "kind": "ScalarField",
            "alias": null,
            "name": "isVerifiedTrade",
            "args": null,
            "storageKey": null
        },
        {
            "kind": "LinkedField",
            "alias": null,
            "name": "profile",
            "storageKey": null,
            "args": null,
            "concreteType": "Profile",
            "plural": false,
            "selections": [
                {
                    "kind": "ScalarField",
                    "alias": null,
                    "name": "firstName",
                    "args": null,
                    "storageKey": null
                }
            ]
        },
        {
            "kind": "LinkedField",
            "alias": null,
            "name": "conversationSummary",
            "storageKey": null,
            "args": null,
            "concreteType": "Summary",
            "plural": false,
            "selections": [
                {
                    "kind": "ScalarField",
                    "alias": null,
                    "name": "unread",
                    "args": null,
                    "storageKey": null
                }
            ]
        },
        {
            "kind": "LinkedField",
            "alias": null,
            "name": "tradeFirm",
            "storageKey": null,
            "args": null,
            "concreteType": "TradeFirmType",
            "plural": false,
            "selections": [
                {
                    "kind": "ScalarField",
                    "alias": null,
                    "name": "profileStatus",
                    "args": null,
                    "storageKey": null
                },
                {
                    "kind": "LinkedField",
                    "alias": null,
                    "name": "publicProfile",
                    "storageKey": null,
                    "args": null,
                    "concreteType": "TradeFirmPublicProfileType",
                    "plural": false,
                    "selections": [
                        {
                            "kind": "ScalarField",
                            "alias": null,
                            "name": "urlLabel",
                            "args": null,
                            "storageKey": null
                        }
                    ]
                },
                {
                    "kind": "LinkedField",
                    "alias": null,
                    "name": "loyalty",
                    "storageKey": null,
                    "args": null,
                    "concreteType": "TradeFirmLoyaltyType",
                    "plural": false,
                    "selections": [
                        {
                            "kind": "ScalarField",
                            "alias": null,
                            "name": "status",
                            "args": null,
                            "storageKey": null
                        }
                    ]
                }
            ]
        },
        {
            "kind": "FragmentSpread",
            "name": "AccountNavContent_user",
            "args": null
        }
    ]
} as any);
(node as any).hash = '703ea456669b456db86422dfe4d171c9';
export default node;
